/* istanbul ignore file */
export * from './AvailabilityInfo';
